import { c as _c } from "react/compiler-runtime";
import './help-me-choose-answers.scss';
import { parseAsInteger, useQueryStates } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionCardsGroup } from '../../../molecules/selection-cards-group/selection-cards-group.tsx';
import { babyImage } from '../images/baby-help-me-choose.ts';
import { childImage } from '../images/child-help-me-choose.ts';
import { oldestImage } from '../images/oldest-help-me-choose.ts';
import { teenImage } from '../images/teen-help-me-choose.ts';
import { createAnswers } from '../utils/answers.ts';
const ageValueLookup: Record<string, 'baby' | 'child' | 'teen' | 'adult'> = {
  '5': 'baby',
  '11': 'child',
  '17': 'teen',
  '22': 'adult'
};
export const HelpMeChooseAge: React.FC = () => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["help-me"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ageMin: parseAsInteger,
      ageMax: parseAsInteger
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [ages, setAges] = useQueryStates(t1);
  let t2;
  if ($[2] !== ages) {
    t2 = ages?.ageMax && ageValueLookup[ages.ageMax.toString()] ? [ageValueLookup[ages.ageMax.toString()]] : [];
    $[2] = ages;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [controlledAges, setControlledAges] = useState(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    const ageValues = [{
      label: "baby",
      max: 5,
      min: 1,
      value: "baby",
      imageUrl: babyImage
    }, {
      label: "child",
      max: 11,
      min: 6,
      value: "child",
      imageUrl: childImage
    }, {
      label: "teen",
      max: 17,
      min: 12,
      value: "teen",
      imageUrl: teenImage
    }, {
      label: "adult",
      max: 22,
      min: 18,
      value: "adult",
      imageUrl: oldestImage
    }];
    t3 = createAnswers("age", ageValues);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const ageAnswers = t3;
  let t4;
  if ($[5] !== setAges) {
    t4 = nextValues => {
      const value = nextValues && nextValues.length > 0 ? nextValues[0] : undefined;
      const isChecked = !!value;
      if (isChecked) {
        const minMax = ageAnswers.find(answer => answer.details.value === value)?.details.minMax;
        if (minMax) {
          setAges({
            ageMin: minMax.min,
            ageMax: minMax.max
          });
        }
      }
      if (!isChecked) {
        setAges(null);
      }
      setControlledAges(isChecked ? [value] : []);
    };
    $[5] = setAges;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleCheckboxChange = t4;
  let t5;
  if ($[7] !== controlledAges) {
    t5 = controlledAges || [];
    $[7] = controlledAges;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("ageAnswers.groupLabel");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleCheckboxChange || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center"><SelectionCardsGroup cards={ageAnswers} selectionMode="single" value={t5} label={t6} onChange={handleCheckboxChange} /></div>;
    $[11] = handleCheckboxChange;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};